import React from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import LinkList from '../../linkList';
import { RouteUrl, V2Route, useGetMatchPage } from '@utils/routeUtil';
import RouterQuery, { UtmOrigin } from '@utils/routeUtil/RouterQuery';

import classnames from 'classnames/bind';
import styles from './banner.module.scss';

const cx = classnames.bind(styles);

const RecommendBanner = () => {
  const matchUrl = useGetMatchPage();
  return (
    <>
      <div className={cx('imgWrap')} />
      <div className={cx('contentsWrap')}>
        <span className={cx('desc')}>매칭신청 전이신가요?</span>
        <strong className={cx('em')}>
          지금 신청하고
          <br />
          기업에게
          <br />
          제안받아보세요!
        </strong>
        <Link
          href={{
            pathname: matchUrl,
            query: {
              ...RouterQuery.getUtmSource(UtmOrigin.Profile),
              ...RouterQuery.getUtmContent(UtmOrigin.Banner),
            },
          }}
          legacyBehavior
        >
          <a className={cx('btn')} role="button">
            바로 가기
          </a>
        </Link>
      </div>
    </>
  );
};

const AccApplyBanner = () => {
  return (
    <>
      <div className={cx('imgWrap', 'type2')} />
      <div className={cx('contentsWrap')}>
        <span className={cx('desc')}>역검응시 전이신가요?</span>
        <strong className={cx('em')}>
          역검 응시하고,
          <br />
          잡다 취업
          <br />
          참여해보자!
        </strong>
        <Link
          href={{
            pathname: RouteUrl.ACCA_TEST_GATE,
            query: {
              ...RouterQuery.getUtmSource(UtmOrigin.Profile),
              ...RouterQuery.getUtmContent(UtmOrigin.Banner),
            },
          }}
          legacyBehavior
        >
          <a className={cx('btn')} role="button">
            바로 가기
          </a>
        </Link>
      </div>
    </>
  );
};

const AccResultGuideBanner = () => {
  return (
    <>
      <div className={cx('imgWrap', 'type3')} />
      <div className={cx('contentsWrap')}>
        <span className={cx('desc')}>역검 결과표 활용법</span>
        <strong className={cx('em')}>
          역검 결과표로
          <br />
          맞춤형 취업 준비를
          <br />
          시작하세요.
        </strong>
        <Link href={V2Route.getJobInfoAcccResultGuidePage()} legacyBehavior>
          <a className={cx('btn')} role="button">
            바로 가기
          </a>
        </Link>
      </div>
    </>
  );
};

const InterviewProposalBanner = () => {
  return (
    <>
      <div className={cx('imgWrap', 'type4')} />
      <div className={cx('contentsWrap')}>
        <span className={cx('desc')}>프로필 입력하셨나요?</span>
        <strong className={cx('em')}>
          프로필을
          <br />
          입력하면
          <br />
          제안 확률업!
        </strong>
        <Link href={RouteUrl.PROFILE} legacyBehavior>
          <a className={cx('btn')} role="button">
            바로 가기
          </a>
        </Link>
      </div>
    </>
  );
};

const Banner = () => {
  const settings = {
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2600,
    fade: true,
    draggable: false,
  };

  return (
    <div className={cx('bannerArea')}>
      <Slider {...settings}>
        <InterviewProposalBanner />
        <RecommendBanner />
        <AccApplyBanner />
        <AccResultGuideBanner />
      </Slider>
      <LinkList />
    </div>
  );
};

export default Banner;
